<div class="work-items">
	<router-outlet>
	</router-outlet>
</div>